import React from 'react'
import { Button, Radio, Image, Modal, Grid } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import ImageAvater from '../../../../drive/Components/ImageAvater';

class EditContributorRole extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.editUserDetails.role
        }
        this.handleSelectParticipants = this.handleSelectParticipants.bind(this);
        this.editParticipants = this.editParticipants.bind(this);
    }

    handleClose = () => {
        dispatch.lifeCycle.modalRoleChangeOpen(false);
    }

    handleSelectParticipants = (e, { value }) => {
        this.setState({ value });
    }

    editParticipants() {
        if (this.props.string === "createPlaybook") {
            let temp = this.props.participantsData.filter((participant) => { return participant.role === 'author' });
            if ((temp.length === 1 && this.state.value === 'author') || (this.props.editUserDetails.role === 'author')) {
                toastr.error('Message', 'Playbook can have only one designer.')
            }
            else {
                for (let i = 0; i < this.props.participantsData.length; i++) {
                    if (this.props.participantsData[i].accountUserId === this.props.editUserDetails.accountUserId) {
                        this.props.participantsData[i].role = this.state.value;
                        break;
                    }
                }
                dispatch.lifeCycle.setParticipantsAsync(this.props.participantsData);
                dispatch.lifeCycle.modalRoleChangeOpen(false);
            }
        }
        else {
            let temp = this.props.selectedPracticeLibrary.participants.filter((participant) => { return participant.role === 'author' });
            if ((temp.length === 1 && this.state.value === 'author') || (this.props.editUserDetails.role === 'author')) {
                toastr.error('Message', 'Playbook can have only one designer.')
            }
            else {
                for (let i = 0; i < this.props.selectedPracticeLibrary.participants.length; i++) {
                    if (this.props.selectedPracticeLibrary.participants[i].accountUserId === this.props.editUserDetails.accountUserId) {
                        this.props.selectedPracticeLibrary.participants[i].role = this.state.value;
                        break;
                    }
                }
                // dispatch.lifeCycle.setParticipantsAsync(this.props.participantsData);
                dispatch.lifeCycle.editParticipantsAsync({ selectedPack: this.props.selectedPracticeLibrary, user: this.props.user })
                dispatch.lifeCycle.modalRoleChangeOpen(false);


            }
        }
    }


    render() {

        const inlineStyle = {
            modal: {
                marginTop: '0px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        const errorLabel = <div className="customErrorLabel" />;
        let userRole;
        if (this.props.selectedPracticeLibrary && !(Object.entries(this.props.selectedPracticeLibrary).length === 0 && this.props.selectedPracticeLibrary.constructor === Object)) {

            userRole = this.props.selectedPracticeLibrary.participants.filter((participant) => { return participant.accountUserId === this.props.user._id })[0];
        } else {
            userRole = this.props.editUserDetails.accountUserId === this.props.user._id
        }
        return (
            <Modal
                size='mini'
                open={this.props.isRoleChangeModalOpen ? true : false}
                centered
                style={inlineStyle.modal}
                className="editRoleModal"
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header style={{ color: '#3fa9f5' }}>Participants
            </Modal.Header>
                <Modal.Content>

                    <Grid>
                        <Grid.Row>
                            <Grid.Column>
                                <ImageAvater imageStyle="h_32 w_32" floated='left' user={this.props.editUserDetails} profilePic={this.props.editUserDetails.imageUrl} />
                                <Grid.Row className="text-cap">
                                    <strong>{this.props.editUserDetails.name}</strong>
                                </Grid.Row>
                                <Grid.Row>
                                    <span>{this.props.editUserDetails.email}</span>
                                </Grid.Row>
                            </Grid.Column>
                        </Grid.Row>

                        <Grid.Row>
                            <Grid.Column>
                                <span style={{ color: '#3fa9f5' }}>Role</span>
                            </Grid.Column>
                        </Grid.Row>

                        <Grid.Row columns={this.props.showResourecePaneFlag !== null || this.props.string === "createPlaybook" ? 3 : 2} inline="true" className="bg-lightBlue">
                            {this.props.showResourecePaneFlag !== null || this.props.string === "createPlaybook" ?
                                <Grid.Column>
                                    <Radio label='Designer'
                                        name='role'
                                        value='author'
                                        checked={this.state.value === 'author'}
                                        onChange={this.handleSelectParticipants}
                                        disabled={userRole && (userRole.role == 'contributor' || userRole.role == 'reviewer')} />
                                </Grid.Column> : ""}
                            <Grid.Column>
                                <Radio label='Reviewer'
                                    name='role'
                                    value='reviewer'
                                    checked={this.state.value === 'reviewer'}
                                    onChange={this.handleSelectParticipants}
                                    disabled={this.props.string === "createPlaybook" && this.props.editUserDetails.accountUserId === this.props.user._id
                                        && this.props.editUserDetails.role === "author" || userRole && (userRole.role == 'contributor' || userRole.role == 'reviewer')}
                                />

                            </Grid.Column>
                            <Grid.Column>
                                <Radio label='Contributor'
                                    name='role'
                                    value='contributor'
                                    checked={this.state.value === 'contributor'}
                                    onChange={this.handleSelectParticipants}
                                    disabled={this.props.string === "createPlaybook" && this.props.editUserDetails.accountUserId === this.props.user._id
                                        && this.props.editUserDetails.role === "author" || userRole && (userRole.role == 'contributor' || userRole.role == 'reviewer')}
                                />

                            </Grid.Column>
                        </Grid.Row>

                    </Grid>

                </Modal.Content>
                <Modal.Actions>

                    <Button className="button-submit float-right" id='addbtn' onClick={this.editParticipants}> Save
                    </Button>
                    <Button className="button-cancel" id='cancelBtn' onClick={this.handleClose}> Cancel
                    </Button>
                </Modal.Actions>
            </Modal >
        )
    }
}

export default EditContributorRole